import storage from 'redux-persist/lib/storage';
import { encryptTransformConfig } from './encryption';
import { createMigrate } from 'redux-persist';

const migrations = {
  2: (state) => {
    return {
      ...state,
      GlobalVariables: {
        ...state.GlobalVariables,
      },
    };
  },
};

const persistConfig = {
  key: 'dcrm',
  version: 1,  // ← add karo
  storage,
  transforms: [encryptTransformConfig],
  whitelist: ['sideExpand', 'user', 'cart', 'admin', 'GlobalVariables'],
  migrate: createMigrate(migrations, { debug: false }),
};

export default persistConfig;